import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconCopy } from 'src/assets/icons/icon-copy.svg';

import Button from 'src/components/button';

import './button-copy.scss';

export enum EButtonCopyType {
  Button = 'button',
  Icon = 'icon',
}

interface IPropsButtonCopy {
  text: string;
  wrapperClass?: string;
  type?: EButtonCopyType;
}

const ButtonCopy: React.FC<IPropsButtonCopy> = ({
  text,
  wrapperClass = '',
  type = EButtonCopyType.Button,
}): JSX.Element => {
  const { t } = useTranslation();

  const [isClickedCopy, setClickedCopy] = useState(false);

  /**
   * useEffect copy text
   */
  useEffect(() => {
    if (isClickedCopy) {
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(text);
      } else {
        unsecuredCopyToClipboard(text);
      }

      setTimeout(() => setClickedCopy(false), 1000);
    }
  }, [isClickedCopy]);

  /**
   * fixed bug for dev environment is being served over HTTP
   */
  const unsecuredCopyToClipboard = (text: string) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  };

  return (
    <div className="tooltip">
      <Button
        wrapperClass={`button-copy ${isClickedCopy ? 'copied' : 'copy'} ${wrapperClass} ${type}`}
        icon={<IconCopy />}
        onEvent={() => setClickedCopy(true)}
      />

      <span className="tooltip-text">{isClickedCopy ? t('TEXT.COPIED') : t('TEXT.COPY')}</span>
    </div>
  );
};

export default ButtonCopy;
